import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'geoBsCenters' as const;

/**
 * Тег бизнес-центра / торгового центра (jsonQuery.bs_center).
 * Имя берётся из серверных гео-тегов (geoTags.bsCenter), иначе — фолбэк.
 */
export const geoBsCentersTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, geoTags }) => {
    const ids = getTermsValue('bs_center')(jsonQuery);

    if (ids === null) {
      return null;
    }

    return ids.map(id => ({
      label: geoTags.bsCenter?.[id] || `Бизнес-центр №${id}`,
      value: createTagValue(ID, id.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const ids = getTermsValue('bs_center')(jsonQuery);

    if (ids === null) {
      return jsonQuery;
    }

    const filteredIds = ids.filter(id => String(id) !== removingTagValue);

    return filteredIds.length ? setTerms('bs_center')(jsonQuery)(filteredIds) : resetTerms(['bs_center'])(jsonQuery);
  },
};
